import React from 'react';
import { Navbar, NavbarLink, NavbarSpacer } from '@app/core';
import { createUseStyles } from 'react-jss';
import { theme, Theme } from '@app/theme';
import { useMatch } from 'react-router-dom';
import classnames from 'classnames';
import { useCurrentParticipantId, useGetNotificationStatus } from '@app/api';

interface Props {
  children?: React.ReactNode;
}

const useStyles = createUseStyles((theme: Theme) => ({
  homeBlueBackground: {},
  homeGrayBackground: {
    background: theme.colors.inkPrimary,
  },
}));

export const ParticipantNavbar = ({ children }: Props) => {
  const classes = useStyles();
  const isHome = useMatch('/');

  const participantId = useCurrentParticipantId();
  const { data: notificationPending } = useGetNotificationStatus(participantId);

  if (isHome) {
    document.body.style.background = theme.colors.inkPrimary;
  } else {
    document.body.style.background = theme.colors.grayBackground;
  }

  return (
    <Navbar
      pageContent={children}
      color="red"
      pageClassName={classnames({
        [classes.homeBlueBackground]: isHome,
        [classes.homeGrayBackground]: !!isHome,
      })}
    >
      <NavbarSpacer />
      <NavbarLink icon="ri-home-line" to="/" />
      <NavbarLink icon="ri-survey-line" to="/studies" />
      <NavbarLink
        icon="ri-notification-2-line"
        to="/notifications"
        notification={notificationPending}
      />
      <NavbarSpacer />
      <NavbarLink icon="ri-user-3-line" to="/profile" />
    </Navbar>
  );
};
